import { useTranslation } from 'react-i18next'

import styles from '../../components/Chat/Calls/LiveKitRoom/notice.module.css'

export const MeetingUnavailable = () => {
  const { t } = useTranslation()

  return (
    <main data-lk-theme="default" className={styles.page}>
      <div className={styles.notice}>
        <div className={styles.icon}>
          <svg width="36" height="36" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
            <path d="M4 6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H4Zm13 4.5 4-2.6a.6.6 0 0 1 1 .5v7.2a.6.6 0 0 1-1 .5l-4-2.6v-3Z" />
            <path d="M3.7 2.3a1 1 0 0 0-1.4 1.4l18 18a1 1 0 0 0 1.4-1.4l-18-18Z" />
          </svg>
        </div>

        <h1 className={styles.title}>{t('meetings.guest.unavailableTitle')}</h1>

        <p className={styles.text}>{t('meetings.guest.unavailableHint')}</p>
      </div>
    </main>
  )
}
